import { render, staticRenderFns } from "./OStep1.vue?vue&type=template&id=10b7aa57&scoped=true"
import script from "./OStep1.vue?vue&type=script&lang=js"
export * from "./OStep1.vue?vue&type=script&lang=js"
import style0 from "./OStep1.vue?vue&type=style&index=0&id=10b7aa57&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b7aa57",
  null
  
)

export default component.exports